/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Payment_1Inputs */

const da_terms_payment_1 = /** @type {(inputs: Terms_Payment_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lærer og ekstra besvarelser betales forud med kort via Stripe. Skole faktureres med 14 dages betalingsfrist. Abonnementer fornyes automatisk for en ny periode (måned eller år), indtil de opsiges. Du får kvittering eller faktura på e-mail.`)
};

/** @type {(inputs: Terms_Payment_1Inputs) => LocalizedString} */
const en_terms_payment_1 = da_terms_payment_1;

/**

* @param {Terms_Payment_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_payment_1 = /** @type {((inputs?: Terms_Payment_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Payment_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_payment_1(inputs)
	return /** @type {LocalizedString} */ ("Lærer og ekstra besvarelser betales forud med kort via Stripe. Skole faktureres med 14 dages betalingsfrist. Abonnementer fornyes automatisk for en ny periode (måned eller år), indtil de opsiges. Du får kvittering eller faktura på e-mail.")
});